
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import coursesImg from "../images/courses.jpg"

export default class About extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <div className="heaerBgImg">
          <Header></Header>
            <div className="header-head">
              <div className='container'><h4>About Us</h4></div>
            </div>
        </div>
        <div className="main-content px-0"> 
          <div className='container'>
            <div className='col-md-12 my-5'>
              <div className='header-head-thin mb-4'>
                <h4>Ivanooo was born out of our passion, the same passion you have for your dream career."</h4>
              </div>
              <p>Hey you all, stuck in the middle. Like you, we too know what it feels not to be whiz-kids or super talented. But what the heck. This beautiful world is as much about us as it is about the rest.</p>
              <p>Like many of you out there, we too have our limitations. We too know what struggle is and the sacrifices that have to be made to reach that goal. Ivanooo was born out of that struggle. It is not that we lack talent. What we need the most is guidance, and the desire to follow it.</p>
              <p>Ivanooo is a guidance platform that handholds you through important phases of your education and career.</p>
              <p>To ease matters, we have built a skill-gap analysis tool which lets you figure out the deficit, if any, in your education and skill set. It then prepares an impartial career plan which consists of the best-fit jobs, courses, institutions and expert analysis that can help you achieve your goals.</p>
              <p>We realise that when it comes to careers, no two journeys are the same. So, let Ivanooo be your guide and help you connect the dots in your journey forward.</p>
              <hr className='my-4'></hr>
            </div>
            <div className='col-md-12'>
              <div className='header-head-thin'>
                <h4>Our Promise</h4>
              </div>
              <div className='row'>
                <div className='col-lg-6 promise-list'>
                  <div className='subhead'>Always Be Searching</div>
                  <p>Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself.</p>
                </div>
                <div className='col-lg-6 promise-list'>
                  <div className='subhead'>Always Be Searching</div>
                  <p>Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself.</p>
                </div>
                <div className='col-lg-6 promise-list'>
                  <div className='subhead'>Always Be Searching</div>
                  <p>Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself.</p>
                </div>
                <div className='col-lg-6 promise-list'>
                  <div className='subhead'>Always Be Searching</div>
                  <p>Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/ivano/about.jsx